import(/* webpackMode: "eager", webpackExports: ["DatadogRum"] */ "/app/app/_shared/DatadogRum.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InventoryHandler"] */ "/app/components/Inventory/InventoryHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InventoryMobileForm"] */ "/app/components/Inventory/InventoryMobileForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkCode"] */ "/app/components/LinkCode/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InventoryFormProvider"] */ "/app/contexts/InventoryFormContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutProvider"] */ "/app/contexts/LayoutContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewInventoryFiltersProvider"] */ "/app/contexts/NewInventoryFiltersContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/env/client.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/_shared/BaseFonts.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/_shared/BaseFonts.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../assets/fonts/helvetica-neue/HelveticaNeue-Bold.ttf\",\"style\":\"normal\",\"weight\":\"700\"},{\"path\":\"../../assets/fonts/helvetica-neue/HelveticaNeue-Medium.ttf\",\"style\":\"normal\",\"weight\":\"500\"},{\"path\":\"../../assets/fonts/helvetica-neue/HelveticaNeue-Regular.ttf\",\"style\":\"normal\",\"weight\":\"400\"}],\"display\":\"swap\",\"variable\":\"--font-helvetica-neue\"}],\"variableName\":\"helveticaNeue\"}");
;
import(/* webpackMode: "eager" */ "/app/styles/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["HandlerGeoLocation"] */ "/app/views/Layout/handlers/HandlerGeoLocation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HandlerPerformanceLogger"] */ "/app/views/Layout/handlers/HandlerPerformanceLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HandlerUtm"] */ "/app/views/Layout/handlers/HandlerUtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutHeader"] */ "/app/views/Layout/LayoutHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewFlag"] */ "/app/views/Layout/PreviewFlag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WrappedInventoryProvider"] */ "/app/views/Layout/WrappedInventoryProvider.tsx");
